import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LogError } from '../../models';
import { BaseCommand } from '../Command';
import { LogCommand } from './log-command';

@Injectable()
export class LogCommandService extends BaseCommand<LogCommand> {
  constructor(
    private readonly httpClient: HttpClient,
    @Inject('apiBaseUrl') private apiBaseUrl: string,
  ) {
    super();
  }

  public execute(params: LogCommand): Observable<void> {
    return this.httpClient
      .post<void>(
        `
        ${this.apiBaseUrl}trial-requests/failure`,
        { ...params },
      )
      .pipe(catchError((err) => throwError(new LogError({ error: err }))));
  }
}
